import type {
  LargeCategorySchema,
  MiddleCategorySchema,
  SmallCategorySchema,
  TinyCategorySchema
} from 'src/models/category/schema';
import type { Category } from 'src/stores/Category';
import { BackendApiFetch } from 'src/utils/backendApi';
import { errorMessage } from 'src/utils/errorMessage';

export const fetchCategories = async (locale: string): Promise<Category> => {
  try {
    const largeCategoriesResponse = await BackendApiFetch<LargeCategorySchema[]>({
      path: '/app/v1/large_categories',
      localeType: locale
    });
    const middleCategoriesResponse = await BackendApiFetch<MiddleCategorySchema[]>({
      path: '/app/v1/middle_categories',
      localeType: locale
    });
    const smallCategoriesResponse = await BackendApiFetch<SmallCategorySchema[]>({
      path: '/app/v1/small_categories',
      localeType: locale
    });
    const tinyCategoriesResponse = await BackendApiFetch<TinyCategorySchema[]>({
      path: '/app/v1/tiny_categories',
      localeType: locale
    });
    const largeCategories = largeCategoriesResponse.data;
    const middleCategories = middleCategoriesResponse.data;
    const smallCategories = smallCategoriesResponse.data;
    const tinyCategories = tinyCategoriesResponse.data;
    return {
      largeCategories: largeCategories.length > 0 ? largeCategories : [],
      middleCategories: middleCategories.length > 0 ? middleCategories : [],
      smallCategories: smallCategories.length > 0 ? smallCategories : [],
      tinyCategories: tinyCategories.length > 0 ? tinyCategories : []
    };
  } catch (e) {
    throw new Error(errorMessage(e));
  }
};

export const fetchLargeCategories = async (locale: string, isStaticProps = false): Promise<LargeCategorySchema[]> => {
  try {
    const response = await BackendApiFetch<LargeCategorySchema[]>({
      path: '/app/v1/large_categories',
      localeType: locale,
      isStaticProps
    });
    if (response.statusCode === 200) return response.data;
    return [];
  } catch (e) {
    throw new Error(errorMessage(e));
  }
};

export const fetchMiddleCategories = async (locale: string): Promise<MiddleCategorySchema[]> => {
  try {
    const response = await BackendApiFetch<MiddleCategorySchema[]>({
      path: '/app/v1/middle_categories',
      localeType: locale
    });
    if (response.statusCode === 200) return response.data;
    return [];
  } catch (e) {
    throw new Error(errorMessage(e));
  }
};

export const fetchSmallCategories = async (locale: string): Promise<SmallCategorySchema[]> => {
  try {
    const response = await BackendApiFetch<SmallCategorySchema[]>({
      path: '/app/v1/small_categories',
      localeType: locale
    });
    if (response.statusCode === 200) return response.data;
    return [];
  } catch (e) {
    throw new Error(errorMessage(e));
  }
};

export const fetchTinyCategories = async (locale: string): Promise<TinyCategorySchema[]> => {
  try {
    const response = await BackendApiFetch<TinyCategorySchema[]>({
      path: '/app/v1/tiny_categories',
      localeType: locale
    });
    if (response.statusCode === 200) return response.data;
    return [];
  } catch (e) {
    throw new Error(errorMessage(e));
  }
};
